import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface DateRange {
  minDate: Date;
  maxDate: Date;
}

@Injectable()
export class CalendarState {
  selectedDateRanges = new BehaviorSubject([]);
  selectedDate = new BehaviorSubject(null);
  get selectedDateRangesSnapshot(): DateRange[] {
    return this.selectedDateRanges.value;
  }
  openCalendarMonth = new BehaviorSubject(new Date());
  minSelectableDate: Date;
  maxSelectableDate;
  selectionType: 'single' | 'singleRange' | 'multiRange';
}
